export default "__VITE_ASSET__m4_xTacc__"